import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import { useFilteredAndSortedRoadmapFeatures } from "../context/hooks";

import { Card } from "./card.tsx";

export const Cards = () => {
    const features = useFilteredAndSortedRoadmapFeatures();
    if (!features) {
        return null;
    }

    return (
        <div css={cardsCss}>
            {features.map((data) => (
                <Card key={data.slug} data={data} />
            ))}
        </div>
    );
};

const cardsCss = css({
    display: "flex",
    flexDirection: "column",
    gap: token("space.300")
});
